import { event } from "../core/EventUtil";
import { KeyCode } from "../io/KeyCode";

export class AriaManager {
    constructor() {
        this.handleButtonRole();
    }

    private handleButtonRole(): void {
        event.on({
            type: "keydown",
            selector: `[data-jsidea-role="button"]`,
            listener: (e) => {
                if (KeyCode.is(e.event, KeyCode.ENTER, KeyCode.SPACE)) {
                    // e.target.click();

                    const bounds = e.target.getBoundingClientRect();
                    const screenX = bounds.left + bounds.width / 2;
                    const screenY = bounds.top + bounds.height / 2;

                    e.target.dispatchEvent(
                        new MouseEvent("click", {
                            bubbles: true,
                            ctrlKey: e.event.ctrlKey,
                            shiftKey: e.event.shiftKey,
                            altKey: e.event.altKey,
                            metaKey: e.event.metaKey,
                            view: e.event.view,
                            detail: 0,
                            screenX: screenX,
                            screenY: screenY,
                            clientX:
                                screenX +
                                (window.pageXOffset ||
                                    document.documentElement.scrollLeft),
                            clientY:
                                screenY +
                                (window.pageYOffset ||
                                    document.documentElement.scrollTop),
                        })
                    );
                }
            },
        });
    }
}
